(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levain-gallery-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-gallery]');
  if (!root) return;

  // Only the first-pass items (not the duplicates) feed the lightbox — otherwise
  // arrow navigation would revisit the same image twice.
  const items = [...root.querySelectorAll('[data-gallery-item]:not([aria-hidden="true"])')];
  // But all items (including duplicates) should still be clickable.
  const allItems = [...root.querySelectorAll('[data-gallery-item]')];
  if (!allItems.length) return;

  const lightbox = root.querySelector('[data-gallery-lightbox]');
  if (!lightbox) return;
  const lbImg    = lightbox.querySelector('[data-gallery-lightbox-img]');
  const btnClose = lightbox.querySelector('[data-gallery-close]');
  const btnPrev  = lightbox.querySelector('[data-gallery-prev]');
  const btnNext  = lightbox.querySelector('[data-gallery-next]');

  let activeIndex = -1;

  function open(i) {
    if (i < 0 || i >= items.length) return;
    activeIndex = i;
    const el = items[i];
    lbImg.src = el.dataset.src;
    lbImg.alt = el.dataset.alt || '';
    lightbox.hidden = false;
    void lightbox.offsetWidth;
    lightbox.setAttribute('data-open', '');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    lightbox.removeAttribute('data-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { lightbox.hidden = true; }, 300);
  }
  function step(delta) {
    if (activeIndex < 0) return;
    const next = (activeIndex + delta + items.length) % items.length;
    open(next);
  }

  // Match the clicked (potentially-duplicate) item to its first-pass twin
  // so the lightbox shows the right starting image.
  allItems.forEach((el) => {
    el.addEventListener('click', () => {
      const src = el.dataset.src;
      const i = items.findIndex(it => it.dataset.src === src);
      if (i >= 0) open(i);
    });
  });
  btnClose.addEventListener('click', close);
  btnPrev .addEventListener('click', () => step(-1));
  btnNext .addEventListener('click', () => step(+1));
  lightbox.addEventListener('click', (e) => { if (e.target === lightbox) close(); });
  document.addEventListener('keydown', (e) => {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft')  step(-1);
    else if (e.key === 'ArrowRight') step(+1);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levain-our-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  const reveals = document.querySelectorAll('[data-story-reveal]');
  if (!reveals.length) return;

  let highlights = [];
  try {
    const raw = document.querySelector('[data-story-highlights]');
    if (raw && raw.textContent.trim()) highlights = JSON.parse(raw.textContent);
  } catch (e) { highlights = []; }

  // The preview works on both pointer (hover) and touch (tap) devices.
  let hoverEl = null;
  if (highlights.length) {
    hoverEl = document.createElement('div');
    hoverEl.className = 'story-hover-img';
    hoverEl.innerHTML = '<img alt="" />';
    document.body.appendChild(hoverEl);
  }

  reveals.forEach(root => {
    if (highlights.length) {
      highlights.forEach(h => wrapFirstMatch(root, h.keyword, h.image));
    }
    splitWords(root);
  });

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  reveals.forEach(r => io.observe(r));

  if (hoverEl) {
    const imgNode = hoverEl.querySelector('img');
    const show = (el, x, y) => {
      const src = el.dataset.img;
      if (!src) return;
      if (imgNode.src !== src) imgNode.src = src;
      hoverEl.style.left = x + 'px';
      hoverEl.style.top  = y + 'px';
      hoverEl.classList.add('is-showing');
    };
    const hide = () => hoverEl.classList.remove('is-showing');

    document.querySelectorAll('.story-hl').forEach(el => {
      // Desktop pointer: show while hovering, follow cursor, hide on exit.
      el.addEventListener('mouseenter', (e) => show(el, e.clientX, e.clientY));
      el.addEventListener('mousemove',  (e) => {
        hoverEl.style.left = e.clientX + 'px';
        hoverEl.style.top  = e.clientY + 'px';
      });
      el.addEventListener('mouseleave', hide);
      // Touch / click: anchor to tap point, keep showing until user taps
      // outside. The click also fires on desktop — it just re-anchors.
      el.addEventListener('click', (e) => {
        show(el, e.clientX, e.clientY);
        e.stopPropagation();
      });
    });

    // Tap anywhere outside a highlight or the popup to dismiss.
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.story-hl') && !e.target.closest('.story-hover-img')) {
        hide();
      }
    });
  }

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function wrapFirstMatch(root, keyword, imgUrl) {
    if (!keyword) return;
    const re = new RegExp('\\b' + escapeRe(keyword) + '\\b', 'i');
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (n.parentElement && n.parentElement.closest('.story-hl')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      const m = node.nodeValue.match(re);
      if (!m) continue;
      const idx = m.index;
      const hit = node.nodeValue.slice(idx, idx + m[0].length);
      const before = node.nodeValue.slice(0, idx);
      const after  = node.nodeValue.slice(idx + m[0].length);
      const frag = document.createDocumentFragment();
      if (before) frag.appendChild(document.createTextNode(before));
      const span = document.createElement('span');
      span.className = 'story-hl';
      span.textContent = hit;
      span.dataset.img = imgUrl;
      frag.appendChild(span);
      if (after) frag.appendChild(document.createTextNode(after));
      node.parentNode.replaceChild(frag, node);
      return;
    }
  }

  function splitWords(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (n.parentElement && n.parentElement.classList.contains('story-word')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);
    let i = 0;
    nodes.forEach(node => {
      const parts = node.nodeValue.split(/(\s+)/);
      const frag = document.createDocumentFragment();
      parts.forEach(p => {
        if (!p) return;
        if (/^\s+$/.test(p)) {
          frag.appendChild(document.createTextNode(p));
        } else {
          const span = document.createElement('span');
          span.className = 'story-word';
          span.style.setProperty('--i', i++);
          span.textContent = p;
          frag.appendChild(span);
        }
      });
      node.parentNode.replaceChild(frag, node);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
